import get from 'lodash/get';

import {
  ActivitySettings,
  ActivityType,
  DiagramGeneralSettings,
  FlowlineSettings,
  PositionType,
  ResourceSettings,
  RichTextSettings,
  StickerNoteSettings
} from '../diagram-type-styles.model';
import {MxCell} from '../../../editor-interface/shared/models/mx-cell.interface';
import {DiagramMetaInterface} from '../../../diagram-data/diagram-meta.interface';
import {isActivity} from '../../helpers/shapes-detectors.util';
import {IResourceJson} from 'src/app/diagram-data/diagram-json-handler.service';
import {stickerCSSClassMapper} from '../../../shared/constants/color-picker.constants';

export abstract class DiagramBaseConfig {
  constructor(protected readonly diagramMeta: DiagramMetaInterface) {}

  abstract generalSettings(): DiagramGeneralSettings;
  abstract activitySettings(x?: number, y?: number): ActivitySettings;
  abstract flowlineSettings(x?: number, y?: number, id?: number | string): FlowlineSettings;
  abstract resourceSettings(resourceCount?: number): ResourceSettings;
  abstract richTextSettings: RichTextSettings;

  abstract readonly activityShape: {w: number; h: number};
  readonly stickerNoteShape: {w: number; h: number} = {w: 150, h: 150};
  readonly activityTypes?: ActivityType[];

  public readonly stickerNoteSettings: StickerNoteSettings = {
    defaultShape: this.stickerNoteShape,
    preparePayload: ({x, y, mxKey, position, color}) => ({
      mxKey,
      position: this.getPosition(this.stickerNoteShape, x, y, position),
      text: '',
      paperClass: get(stickerCSSClassMapper, color, 'yellow-paper-gold')
    })
  };

  protected getDefaultResources(keys: string[]): IResourceJson[] {
    const defaultResourceConfig = {
      hidden: false,
      main: false,
      rasci: {
        responsible: false,
        accountable: false,
        supporting: false,
        consulted: false,
        informed: false
      }
    };

    return keys.reduce((acc, key, index) => {
      const resource = this.diagramMeta?.defaultResources?.[key];

      if (resource) {
        acc.push({
          mxKey: index + 1,
          ...resource,
          ...defaultResourceConfig
        });
      }

      return acc;
    }, []);
  }

  protected calculateAdditionalHeight(cell: MxCell): number {
    const RES_HEIGHT = 24;

    return isActivity(cell) && cell.comp.instance.source.resources
      ? cell.comp.instance.source.resources.length * RES_HEIGHT
      : 0;
  }

  protected getPosition(
    shape: {w: number; h: number},
    x?: number,
    y?: number,
    position?: PositionType
  ): {x: number; y: number; h: number; w: number} {
    switch (position) {
      case PositionType.CENTER:
        return {
          x: x ? x - shape.w / 2 : 0,
          y: y ? y - shape.h / 2 : 0,
          w: shape.w,
          h: shape.h
        };

      case PositionType.DEFAULT:

      default:
        return {
          x: x || 0,
          y: y || 0,
          w: shape.w,
          h: shape.h
        };
    }
  }
}
